module.exports = __webpack_public_path__ + "static/media/twiter-footer.f5378e6b.webp";